<div data-automation="phone-service-subscriptions-form">
  <ziro-fieldset-header [legend]="'tkey;shared.device.phone.service_subscriptions.header' | translate">
    <ziro-navset data-automation="phone-service-subscriptions-navset" fieldId="serviceSubscriptions"></ziro-navset>
  </ziro-fieldset-header>
</div>
